import { takeLatest, call, put, all } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import Api from '../../utils/Api';
import ProfileTypes from './profile.types';
import UtilsTypes from '../utilities/utils.types.js';
import { clearLocalStorage } from '../../utils/commonFunctions';
import Loader from '../../utils/Loader';
import UserProfileTypes from '../userDetails/userDetails.actionTypes';

function* setErrorPanel(errorPanel) {
	Loader.hide();
	yield put({ type: UtilsTypes.SET_ERROR_PANEL, payload: errorPanel });
}

function* setError(msg) {
	if (msg === 'Token is Invalid' || msg === 'Token is missing') {
		clearLocalStorage();
		yield put(push('/'));
	} else {
		yield put({ type: UtilsTypes.SET_ERROR_MSG, payload: msg });
	}
	Loader.hide();
}

function* updateUserProfile({
	payload: { phone, email, full_name, is_olympiad, isCoachCall },
}) {
	try {
		const res = yield call(Api, {
			url: 'user_profile',
			method: 'POST',
			data: {
				phone,
				email,
				is_olympiad,
				full_name,
			},
			headers: { 'access-token': localStorage.getItem('token') },
		});
		if (!res.status) {
			yield call(setErrorPanel, {
				panelMsg: res,
				panelClass: 'alert alert-danger',
			});
		} else {
			if (res.code === 200 || res.code === 201) {
				Loader.hide();
				yield call(setErrorPanel, {
					panelMsg: `User details updated successfully.${isCoachCall ? 'Redirecting to calendar.' : ''
						}`,
					panelClass: 'alert alert-success',
				});
				let userDetailsObj = {};
				userDetailsObj.user_mail = email;
				userDetailsObj.user_phone = phone;
				userDetailsObj.full_name = full_name;

				localStorage.setItem('userDetails', JSON.stringify(userDetailsObj));
				yield put({
					type: ProfileTypes.UPDATE_PROFILE_DETAILS.SUCCESS,
					payload: { isScheduleCall: isCoachCall ? true : false },
				});
				yield put({ type: ProfileTypes.SHOW_USER_MODAL, payload: false });
				window.location.reload();
			} else {
				yield call(setErrorPanel, {
					panelMsg: res.message,
					panelClass: 'alert alert-danger',
				});
			}
		}
	} catch (err) {
		console.log('profile error', err);
	}
}

function* addProfileDetails({ payload }) {
	const {
		age,
		gender,
		whatsappNumber,
		email,
		phone,
		isParent,
		receiveWhatsappNotification,
		fullName: full_name,
		userType: user_type,
		primaryPurpose: primary_purpose,
		Child,
		isSubscribe,
		isMobVerified,
	} = payload;
	let childrenAge = Child?.filter((x) => !!x?.age)
		?.map((x) => x?.age)
		?.join(',');

	try {
		const res = yield call(Api, {
			url: 'v3/user_profile',
			method: 'POST',
			data: {
				age,
				gender,
				whatsappNumber,
				email,
				phone,
				isParent: isParent ? '1' : '0',
				receiveWhatsappNotification: receiveWhatsappNotification ? '1' : '0',
				full_name,
				user_type,
				primary_purpose,
				childrenAge,
				isSubscribe: isSubscribe ? '1' : '0',
				isMobVerified,
			},
			headers: { 'access-token': localStorage.getItem('token') },
		});
		if (!res?.status) {
			yield call(setError, res);
		} else {
			if (res?.code === 200) {
				Loader.hide();

				yield call(setErrorPanel, {
					panelMsg: res?.message,
					panelClass: 'alert alert-success',
				});

				let userDetailsObj = {
					user_mail: email,
					full_name,
					user_phone: phone,
				};
				localStorage.setItem('userDetails', JSON.stringify(userDetailsObj));

				yield put({ type: ProfileTypes.TOGGLE_PROFILE_EDIT });
				yield put({
					type: UserProfileTypes.SET_USER_DETAILS,
					payload: { fullName: full_name },
				});
			} else {
				yield call(setError, res.message);
			}
		}
	} catch (err) {
		console.log('profile error', err);
	}
}

function* updateCoachStream({ payload }) {
	const {
		user_background,
		user_role,
		user_skill,
	} = payload;

	try {
		const res = yield call(Api, {
			url: 'updateuserrole',
			method: 'POST',
			data: {
				user_background: user_background,
				user_role: user_role,
				user_skill: user_skill,
			},
			headers: { 'access-token': localStorage.getItem('token') },
		});
		if (!res.status) {
			yield call(setError, res);
		} else {
			if (res.code === 200) {
				Loader.hide();

				localStorage.setItem('coachMessageTemp', 1);
				window.location.reload();
			} else {
				yield call(setError, res.message);
			}
		}
	} catch (err) {
		console.log('coach stream error', err);
	}
}

function* addOnboardDetails({ payload }) {
	const {
		whatsappNumber,
		isParent,
		receiveWhatsappNotification,
		userType: user_type,
		Child,
		phone,
		isSubscribe,
		email,
		fullname,
	} = payload;
	let childrenAge = Child?.filter((x) => !!x.age)
		?.map((x) => x.age)
		?.join(',');

	try {
		const res = yield call(Api, {
			url: 'onboarding',
			method: 'POST',
			data: {
				whatsappNumber,
				isParent,
				receiveWhatsappNotification,
				user_type,
				childrenAge,
				phone,
				isSubscribe,
				email,
				full_name: fullname,
			},
			headers: { 'access-token': localStorage.getItem('token') },
		});
		if (!res.status) {
			if (
				res === 'Phone number exists for another user' ||
				res === 'Email address exists for another user'
			) {
				yield put(push('/onboard/step4'));
			}

			yield call(setError, res);
		} else {
			if (res.code === 200) {
				Loader.hide();
				localStorage.removeItem('onboardPending');
				yield put({ type: ProfileTypes.GET_PROFILE_DETAILS.PENDING });
			} else {
				yield call(setError, res.message);
			}
		}
	} catch (err) {
		console.log('profile error', err);
	}
}

function* getProfileDetails() {
	try {
		const res = yield call(Api, {
			url: 'v3/user_profile',
			method: 'GET',
			headers: { 'access-token': localStorage.getItem('token') },
		});
		if (!res.status) {
			yield call(setError, res);
		} else {
			if (res.code === 200) {
				Loader.hide();
				yield put({
					type: ProfileTypes.GET_PROFILE_DETAILS.SUCCESS,
					payload: res.data,
				});
			} else {
				yield call(setError, res.message);
			}
		}
	} catch (err) {
		console.log('profile error', err);
	}
}

function* resetPin() {
	try {
		const res = yield call(Api, {
			url: 'resetpin',
			method: 'GET',
			headers: { 'access-token': localStorage.getItem('token') },
		});
		if (!res.status) {
			yield call(setError, res);
		} else {
			if (res.code === 200) {
				Loader.hide();
				yield call(setErrorPanel, {
					panelMsg: res.message,
					panelClass: 'alert alert-success',
				});
			} else {
				yield call(setError, res.message);
			}
		}
	} catch (err) {
		console.log('profile error', err);
	}
}

function* sendOtp({ payload }) {
	try {
		const res = yield call(Api, {
			url: 'sendOTP',
			method: 'POST',
			data: { mobile: payload },
			headers: { 'access-token': localStorage.getItem('token') },
		});
		if (!res.status) {
			yield call(setError, res);
		} else {
			if (res.code === 200) {
				Loader.hide();
				yield put({ type: ProfileTypes.SEND_MOBILE_OTP.SUCCESS });

				yield put({ type: ProfileTypes.SHOW_VERIFY_MOB, payload: true });
			} else {
				yield call(setError, res.message);
			}
		}
	} catch (err) {
		console.log('profile error', err);
	}
}

function* verifyOtp({ payload }) {
	try {
		const res = yield call(Api, {
			url: 'verifyOTP',
			method: 'POST',
			data: { otp: payload },
			headers: { 'access-token': localStorage.getItem('token') },
		});
		if (!res.status) {
			yield call(setErrorPanel, {
				panelMsg: res,
				panelClass: 'alert alert-danger',
			});
		} else {
			if (res.code === 200) {
				Loader.hide();
				yield put({ type: ProfileTypes.SHOW_VERIFY_MOB, payload: false });
				yield put({ type: ProfileTypes.VERIFY_MOBILE_OTP.SUCCESS });
				yield call(setErrorPanel, {
					panelMsg: res.message,
					panelClass: 'alert alert-success',
				});
			} else {
				yield call(setErrorPanel, {
					panelMsg: res.message,
					panelClass: 'alert alert-danger',
				});
			}
		}
	} catch (err) {
		console.log('profile error', err);
	}
}

function* setSubscription({ payload }) {
	try {
		const res = yield call(Api, {
			url: 'updateSubscribe  ',
			method: 'POST',
			data: { ...payload },
			headers: { 'access-token': localStorage.getItem('token') },
		});
		if (!res.status) {
			yield call(setErrorPanel, {
				panelMsg: res,
				panelClass: 'alert alert-danger',
			});
		} else {
			if (res.code === 200) {
				Loader.hide();
				yield put({
					type: ProfileTypes.SUBCRIBE_FOR_UPDATES.SUCCESS,
					payload: payload.isSubscribe,
				});
				yield put({
					type: ProfileTypes.SHOW_SUBSCRIBE,
					payload: false,
				});
			} else {
				yield call(setErrorPanel, {
					panelMsg: res.message,
					panelClass: 'alert alert-danger',
				});
			}
		}
	} catch (err) {
		console.log('profile error', err);
	}
}

function* getUserProfileStart() {
	yield takeLatest(ProfileTypes.GET_PROFILE_DETAILS.PENDING, getProfileDetails);
}

function* addProfileDetailsStart() {
	yield takeLatest(ProfileTypes.ADD_PROFILE_DETAILS.PENDING, addProfileDetails);
}

function* updateCoachStreamStart() {
	yield takeLatest("UPDATE_COACH_STREAM_PENDING", updateCoachStream);
}

function* updateUserProfileStart() {
	yield takeLatest(
		ProfileTypes.UPDATE_PROFILE_DETAILS.PENDING,
		updateUserProfile,
	);
}

function* addOnboardDetailsStart() {
	yield takeLatest(ProfileTypes.ADD_ONBOARD_DETAILS.PENDING, addOnboardDetails);
}

function* resetPinStart() {
	yield takeLatest(ProfileTypes.RESET_PIN, resetPin);
}

function* sendOTPStart() {
	yield takeLatest(ProfileTypes.SEND_MOBILE_OTP.PENDING, sendOtp);
}

function* verifyOTPStart() {
	yield takeLatest(ProfileTypes.VERIFY_MOBILE_OTP.PENDING, verifyOtp);
}

function* setSubscriptionStart() {
	yield takeLatest(ProfileTypes.SUBCRIBE_FOR_UPDATES.PENDING, setSubscription);
}

export function* profileSagas() {
	yield all([
		call(updateUserProfileStart),
		call(getUserProfileStart),
		call(addProfileDetailsStart),
		call(resetPinStart),
		call(addOnboardDetailsStart),
		call(sendOTPStart),
		call(verifyOTPStart),
		call(setSubscriptionStart),
		call(updateCoachStreamStart),
	]);
}